import { useEffect, useState } from 'react';
import { selectApi } from '@/modules/calendar/api';
import { DataRelease } from '@/modules/calendar/model/calendar/data-release';
import { InputGroup } from 'react-bootstrap';
import DataReleaseHistory from '@/modules/calendar/components/data/data-release-history';

export default function DataReleaseHistoryNavigator() {
  const [dataReleases, setDataReleases] = useState<DataRelease[]>([]);
  const [, setDataReleasesByCountry] = useState<DataRelease[]>([]);
  const [countries, setCountries] = useState<string[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>();
  const [selectedDataRelease, setSelectedDataRelease] = useState<string>();

  useEffect(() => {
    selectApi.getAllReleases().then(setDataReleases);
  }, []);

  useEffect(() => {
    const allCountries = dataReleases.map(value => value.country);
    const uniqueCountries = [...new Set(allCountries)].sort();

    setCountries(uniqueCountries);
    setSelectedCountry(uniqueCountries[0]);
  }, [dataReleases]);

  useEffect(() => {
    if (!selectedCountry) return;

    const releases = dataReleases
      .filter(value => value.country === selectedCountry)
      .sort((a, b) => a.title.localeCompare(b.title));

    setDataReleasesByCountry(releases);
    setSelectedDataRelease(`${releases[0].id}`);
  }, [selectedCountry, dataReleases]);

  return (
    <div className={'container-element h-100 d-flex flex-column'}>
      <div className={'mb-3'}>
        <InputGroup>
          <select
            className={'form-select form-select-sm w-25'}
            onChange={event => setSelectedCountry(event.target.value)}
          >
            {countries.map(value => (
              <option>{value}</option>
            ))}
          </select>
          <select
            className={'form-select form-select-sm w-75'}
            onChange={event => setSelectedDataRelease(event.target.value)}
          >
            {dataReleases
              .filter(value => value.country === selectedCountry)
              .map(value => (
                <option value={value.id}>{value.title}</option>
              ))}
          </select>
        </InputGroup>
      </div>
      <div className={'flex-fill overflow-auto h-100'}>
        {selectedDataRelease && (
          <DataReleaseHistory
            dataReleaseId={parseInt(selectedDataRelease)}
            date={new Date().toISOString()}
          />
        )}
      </div>
    </div>
  );
}
